import groupBy from 'lodash/groupBy';

import type { GetClassStudentAnswersQuery } from '../../present/activity-answers.graphql.generated';
import type { InteractiveResponseAnswerFragment } from '../../present/activity-answers.graphql.generated';
import type { Pluck } from 'lib/gql/pluck';

export function prepareClassResults(
  studentAnswers: Pluck<
    GetClassStudentAnswersQuery,
    'getClassStudentsAnswers'
  >[]
) {
  const groupedByStudentId = groupBy(studentAnswers, 'studentId');
  const answerTally = { correct: 0, incorrect: 0 };

  Object.values(groupedByStudentId).forEach(student => {
    if (
      (
        student[0].answer as InteractiveResponseAnswerFragment
      ).interactiveResponseItems.every(answer => answer.isCorrect)
    ) {
      answerTally.correct += 1;
    } else {
      answerTally.incorrect += 1;
    }
  });

  return answerTally;
}
